import {
  QuestionCard,
  QuestionHeader,
  QuestionNumber,
  QuestionTextContainer,
  QuestionText,
  QuestionTranslation,
  AnswerContainer,
  AnswerText,
} from './QuestionCard'

// Helper function to check if a translation exists and is not English
function getNonEnglishTranslation(translations) {
  if (!translations) return null
  
  // Check for Hindi translation
  if (translations.hi?.questionText) {
    return translations.hi.questionText
  }
  
  // Check for other language translations (excluding English)
  const languageCodes = Object.keys(translations)
  for (const langCode of languageCodes) {
    if (langCode !== 'en' && translations[langCode]?.questionText) {
      return translations[langCode].questionText
    }
  }
  
  return null
}

export default function PdfReportQuestionAnswer({ question, questionNumber }) {
  const hasAnswer = !!(question?.answer?.response || question?.answer?.additionalResponse)
  const hasResponse = !!question?.answer?.response
  const hasAdditionalResponse = !!question?.answer?.additionalResponse
  
  // Get question text (use questionText, not shortQuestionText)
  const questionText = question?.questionText || question?.shortQuestionText || 'Question'
  
  // Get translated question text if it exists and is not English
  const translatedQuestionText = getNonEnglishTranslation(question?.translations)
  
  return (
    <QuestionCard $hasAnswer={hasAnswer}>
      <QuestionHeader>
        <QuestionNumber $hasAnswer={hasAnswer}>
          {questionNumber}
        </QuestionNumber>
        <QuestionTextContainer>
          {/* Question Text */}
          <QuestionText style={{ marginBottom: translatedQuestionText ? '6px' : hasResponse ? '10px' : '0' }}>
            {questionText}
          </QuestionText>
          
          {/* Translated Question Text (if exists and not English) */}
          {translatedQuestionText && (
            <QuestionTranslation style={{ marginBottom: hasResponse ? '10px' : '0' }}>
              {translatedQuestionText}
            </QuestionTranslation>
          )}
        </QuestionTextContainer>
      </QuestionHeader>
      
      {/* Answer - Full text, not cut */}
      {hasResponse && (
        <AnswerContainer $hasAnswer={hasAnswer} style={{ marginTop: '8px' }}>
          <AnswerText style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {question.answer.response}
          </AnswerText>
        </AnswerContainer>
      )}
      
      {/* Note - Only show if additionalResponse exists */}
      {hasAdditionalResponse && (
        <div style={{ 
          marginTop: hasResponse ? '10px' : '8px',
          paddingTop: hasResponse ? '10px' : '0',
          borderTop: hasResponse ? '1px solid rgba(203, 213, 225, 0.3)' : 'none',
          fontSize: '13px',
          color: '#475569',
          lineHeight: '1.6',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}>
          <strong style={{ color: '#64748b', fontWeight: 600 }}>Note:</strong>{' '}
          <span style={{ color: '#334155' }}>{question.answer.additionalResponse}</span>
        </div>
      )}
      
      {/* Show "Not answered" if no answer at all */}
      {!hasAnswer && (
        <div style={{ 
          marginTop: '8px',
          fontSize: '12px',
          color: '#94a3b8',
          fontStyle: 'italic',
        }}>
          (Not answered)
        </div>
      )}
    </QuestionCard>
  )
}
